import { Navigate, useParams } from 'react-router-dom';
import { NEED_IDS } from '../data/offerings';

/** Legacy deep links → filter view (modal is the primary brief). */
export function ServiceDetailPage() {
  const { offerId } = useParams();

  if (!offerId || !NEED_IDS.includes(offerId)) {
    return <Navigate to="/services?need=lead" replace />;
  }

  return <Navigate to={`/services?need=${offerId}`} replace />;
}
